"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const SvgIcon_vue_1 = __importDefault(require("./SvgIcon/SvgIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedButtonOnlyIcon',
    props: {
        iconName: {},
        iconSize: { default: "5" },
        dataTestName: { default: "" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", (0, vue_2.normalizeProps)({
                type: "button",
                class: "inline-grid select-none place-content-center whitespace-nowrap rounded-full align-top disabled:text-gray-50",
                [_ctx.dataTestName || ""]: '',
                style: { "-webkit-tap-highlight-color": "transparent" }
            }), [
                (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                    class: (0, vue_2.normalizeClass)(`size-${_ctx.iconSize}`),
                    "icon-name": _ctx.iconName
                }, null, 8, ["class", "icon-name"])
            ], 16));
        };
    }
});
